// 隧洞信息发布-状态列表
export const statusList = [
  { label: '出渣', value: 1 },
  { label: '装药', value: 2 },
  { label: '清场', value: 3 },
  { label: '爆破', value: 4 }
]

// 隧洞信息发布-状态字典
export const statusMap = {
  1: '出渣中',
  2: '装药中',
  3: '清场中',
  4: '爆破中'
}

export const statusMapView = {
  1: '出渣',
  2: '装药',
  3: '清场',
  4: '爆破'
}

// 隧洞下拉列表
export const tunnelList = [
  { label: '1#导流洞', value: '1#导流洞' },
  { label: '2#导流洞', value: '2#导流洞' },
  { label: '生态退水洞', value: '生态退水洞' },
  { label: '1#尾水洞', value: '1#尾水洞' },
  { label: '2#尾水洞', value: '2#尾水洞' },
  { label: '生态泄放尾水洞', value: '生态泄放尾水洞' }
]

// 级别下拉列表
export const levelList = [
  { label: 'Ⅰ', value: 1 },
  { label: 'Ⅱ', value: 2 },
  { label: 'Ⅲ', value: 3 },
  { label: 'Ⅳ', value: 4 },
  { label: 'Ⅴ', value: 5 },
  { label: 'Ⅵ', value: 6 }
]

// 级别下拉列表-字典
export const levelMap = {
  1: 'Ⅰ',
  2: 'Ⅱ',
  3: 'Ⅲ',
  4: 'Ⅳ',
  5: 'Ⅴ',
  6: 'Ⅵ'
}

// 预警等级下拉列表
export const warnList = [
  { label: 'Ⅰ级', value: 1 },
  { label: 'Ⅱ级', value: 2 },
  { label: 'Ⅲ级', value: 3 }
]

// 预警等级下拉列表-字典
export const warnMap = {
  1: 'Ⅰ级',
  2: 'Ⅱ级',
  3: 'Ⅲ级'
}
